import React from 'react'

import './styles.scss'
import Nixi1Spinner from 'components/Nixi1Spinner'
import Toggle from 'components/forms/Toggle'
import ActionsCell from './ActionsCell'

/**
 * Basic Table
 * @param {object} props
 * @param {[{
 *  label?: string,
 *  component?: React.Component,
 *  field: string,
 *  filedType?: 'toggle',
 *  className: string
 * }]} props.headRows
 * @param {[{
 *   _id: string,
 *   [string]: *
 * }]} props.rows
 * @param {boolean} [props.isLoading]
 * @param {boolean} [props.displayActions]
 * @param {string} [props.notResultText]
 * @param {string} [props.className]
 * @param {function} [props.onRemove]
 * @param {function} [props.onEdit]
 *
 * @returns {React.Component}
 */
export default function BasicTable(props) {
  const {
    rows = [], headRows = [], displayActions = false,
    onEdit, onRemove, isLoading = false, notResultText = '',
    className = ''
  } = props

  return (
    <div className={`nx-basic-table ${className}`}>
      <div className='nx-basic-table__head'>
        {
          headRows.map((elem, idx) => {
            const { label, component, className = '' } = elem

            let content = label || component || ''

            return (
              <div
                key={idx}
                className={`nx-basic-table__head-cell ${className}`}
              >
                {content}
              </div>
            )
          })
        }
        {
          displayActions
            ? (
              <div
                key='actions'
                className='nx-basic-table__head-cell nx-basic-table__actions'
              />
            )
            : null
        }
      </div>
      <div className='nx-basic-table__body'>
        {
          rows.map((row, idx) => (
            <div
              className={`nx-basic-table__body-row${idx%2 === 0 ? '' : '-odd'}`}
              key={row._id}
            >
              {
                headRows.map((head, idx) => {
                  const value = row[head.field] || ''

                  return (
                    <div
                      key={`${row._id}_${idx}`}
                      className={`nx-basic-table__body-cell ${head.className || ''} ${head.bodyNotEllipsis ? 'cell-without-ellipsis' : ''}`}
                      title={head.title ? value : null}
                    >
                      {
                        head.filedType === 'toggle'
                          ? (
                            <div>
                              <Toggle
                                value={!!value}
                                onClick={head.onToggle ? () => head.onToggle(row) : null}
                              />
                            </div>
                          )
                          : value || ''
                      }
                    </div>
                  )
                })
              }
              {
                displayActions
                  ? (
                    <ActionsCell
                      key={`${row._id}_actions`}
                      item={row}
                      onEdit={onEdit}
                      onRemove={onRemove}
                    />
                  )
                  : null
              }
            </div>
          ))
        }
        {
          !isLoading && !rows.length && notResultText
            ? (
              <div
                className='nx-basic-table__body-row'
              >
                {notResultText}
              </div>
            )
            : null
        }
        {
          isLoading
            ? (
              <div className='nx-basic-table__body-loading'>
                <Nixi1Spinner
                  height='2rem' width='2rem'
                />
              </div>
            )
            : null
        }
      </div>
    </div>
  )
}
